import React, { useState, useEffect } from 'react';
import { Questionnaire } from '../../views/CJMSView/components/Questionnaire';

const QuestionnairePage: React.FC = () => {
  const [leadId, setLeadId] = useState('anonymous');
  const [email, setEmail] = useState('');

  useEffect(() => {
    try {
      const stored = localStorage.getItem('userProfile');
      if (stored) {
        const profile = JSON.parse(stored);
        if (profile.id) setLeadId(profile.id);
        if (profile.email) setEmail(profile.email);
      }
    } catch {
      // fallback to anonymous
    }
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <Questionnaire
        leadId={leadId}
        email={email}
        onComplete={(responses) => {
          console.log('Questionnaire completed:', responses);
        }}
        onCancel={() => {
          window.history.back();
        }}
      />
    </div>
  );
};

export default QuestionnairePage;
